import { Component, Input, Output, EventEmitter } from '@angular/core';

import { IconComponent } from '../../../icon/icon.component';

@Component({
  selector: 'app-learner-landing-page',
  standalone: true,
  imports: [IconComponent],
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss']
})
export class LandingPageComponent {
  @Input() courseData: any;
  @Input() isReturningLearner = false;
  @Input() totalUnitsCount = 0;
  @Input() totalModulesCount = 0;
  @Input() canSelfReset = false;
  @Input() resetsUsed = 0;
  @Input() maxResets: number | null = null;
  // Audit finding #3 — when the learner has already finished the course,
  // the returning-learner CTA should read "Replay Course" instead of
  // "Resume Course" (which implies unfinished progress).
  @Input() isCompleted = false;

  @Output() onStart = new EventEmitter<void>();
  @Output() onResume = new EventEmitter<void>();
  @Output() onSkip = new EventEmitter<void>();
  @Output() onReset = new EventEmitter<void>();
  @Output() onCloseModal = new EventEmitter<void>();

  isDescriptionExpanded = false;
  showResetConfirmation = false;
  isResetting = false;

  toggleDescriptionExpand(): void {
    this.isDescriptionExpanded = !this.isDescriptionExpanded;
  }

  isDescriptionLong(text: string | undefined | null, threshold: number = 300): boolean {
    if (!text) return false;
    const strippedText = text.replace(/<[^>]*>/g, '');
    return strippedText.length > threshold;
  }

  confirmReset(): void {
    this.showResetConfirmation = true;
  }

  cancelReset(): void {
    this.showResetConfirmation = false;
  }

  executeReset(): void {
    this.isResetting = true;
    this.showResetConfirmation = false;
    this.onReset.emit();
  }
}
